import { Tag, Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { displayMessage } from '../../../helpers/messages';

export const userGridColumns = (handleEdit) => [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 80,
    sorter: (a, b) => a.id - b.id,
  },
  {
    title: displayMessage('FIRST_NAME'),
    dataIndex: 'first_name',
    key: 'first_name',
    sorter: (a, b) => (a.first_name || '').localeCompare(b.first_name || ''),
  },
  {
    title: displayMessage('LAST_NAME'),
    dataIndex: 'last_name',
    key: 'last_name',
    sorter: (a, b) => (a.last_name || '').localeCompare(b.last_name || ''),
  },
  {
    title: displayMessage('EMAIL'),
    dataIndex: 'email',
    key: 'email',
    sorter: (a, b) => (a.email || '').localeCompare(b.email || ''),
  },
  {
    title: displayMessage('STATUS'),
    dataIndex: 'is_active',
    key: 'is_active',
    width: 120,
    render: (is_active) => (
      <Tag color={is_active ? 'green' : 'red'}>
        {is_active ? displayMessage('ACTIVE') : displayMessage('INACTIVE')}
      </Tag>
    ),
    sorter: (a, b) => (a.is_active === b.is_active ? 0 : a.is_active ? -1 : 1),
  },
  {
    title: displayMessage('ACTIONS'),
    key: 'actions',
    width: 100,
    render: (_, record) => (
      <Button
        type="primary"
        icon={<EditOutlined />}
        size="small"
        onClick={() => handleEdit(record)}
      >
        {displayMessage('EDIT')}
      </Button>
    ),
  },
];



